import { useEffect } from 'react';
import "./HelpCenter.css";

type HelpCenterProps = {
};

export const HelpCenter = ({} : HelpCenterProps) => {
    return (
        <div id="help-center">
            
            <div className="help-center-header">
                <div className="page-title">
                    Help Center
                </div>
            </div>

            <div className="help-center-body">
                Coming soon...
            </div>
        </div>
    )
}